import { render, staticRenderFns } from "./serve.vue?vue&type=template&id=f859b976&scoped=true&"
import script from "./serve.vue?vue&type=script&lang=js&"
export * from "./serve.vue?vue&type=script&lang=js&"
import style0 from "./serve.vue?vue&type=style&index=0&id=f859b976&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f859b976",
  null
  
)

export default component.exports